import { useTheme } from "@emotion/react";
import Pdf from "react-to-pdf";
import {
  Backdrop,
  Badge,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getOrder } from "../actions/ordrActions";
import { Download } from "@mui/icons-material";

const Invoice = () => {
  const ref = React.createRef();

  const params = useParams();

  const orderGet = useSelector((state) => state.orderGet);
  const { order, loading } = orderGet;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const { palette } = useTheme();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (params.id) {
      dispatch(getOrder(params.id));
    }
  }, [params.id, userInfo, navigate]);

  return (
    <>
      {loading && (
        <Backdrop open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Box pt={10}>
        <>
          {order && (
            <Grid container spacing={1}>
              <>
                {/* create a simple invoice with table of items 
                and total price     
                */}
                <Pdf targetRef={ref} filename={`${order._id}.pdf`}>
                  {({ toPdf }) => (
                    <IconButton
                      color="primary"
                      variant="contained"
                      onClick={toPdf}
                    >
                      <Download />
                      Generate Pdf
                    </IconButton>
                  )}
                </Pdf>
              </>
              <Grid item xs={12}>
                <Card ref={ref}>
                  <CardHeader subheader={`Invoice for order id ${params.id}`} />

                  <CardContent>
                    <Grid container spacing={6}>
                      <Grid item xs={6} md={6}>
                        <Typography color={palette.primary.main} variant="h6">
                          Company information
                        </Typography>
                        <Typography variant="body1">
                          Company: Group word
                        </Typography>
                        <Typography variant="body1">
                          PhoneNumber:0729842998
                        </Typography>
                        <Typography variant="body1">
                          Address: Juja gate c
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}></Grid>
                      <Grid item xs={6} md={6}></Grid>
                      <Grid item xs={6} md={6}>
                        <Typography color={palette.success.main} variant="h6">
                          Customer information
                        </Typography>
                        <Typography variant="body1">
                          Name: {order.customerName}
                        </Typography>
                        <Typography variant="body1">
                          PhoneNumber: {order.customerPhone}
                        </Typography>
                        <Typography variant="body1">
                          Address: {order.customerAddress}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Typography color={palette.primary.main} variant="h6">
                          Order information
                        </Typography>

                        <TableContainer>
                          <Table aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell> Product</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Total Price</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order &&
                                order.orderItems.map((row) => (
                                  <TableRow key={row._id}>
                                    <TableCell component="th" scope="row">
                                      {row.product && row.product.name}{" "}
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                      {row.qty}
                                    </TableCell>

                                    <TableCell>{row.price}</TableCell>
                                    <TableCell>{row.qty * row.price}</TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>

                          <Typography variant="h6">
                            Total price: {order.totalPrice}
                          </Typography>
                          <Typography variant="h6">
                            Discount price: {order.discount}
                          </Typography>
                          <Typography variant="h6">
                            {order.paid ? (
                              <Button color="primary">Paid</Button>
                            ) : (
                              <Button color="danger">Not Paid</Button>
                            )}
                          </Typography>
                          <Typography variant="h6">
                            {order.shipped ? (
                              <Button color="primary"> Shipped</Button>
                            ) : (
                              <Button color="danger">Not Shipped</Button>
                            )}
                          </Typography>
                          <Typography
                            sx={{
                              border: "1px solid",
                              borderRadius: "5px",
                              padding: "10px",
                              marginTop: "10px",
                              width: "200px",
                            }}
                            variant="h6"
                            component="p"
                            color={palette.success.main}
                          >
                            Total: Ksh {order.totalPrice - order.discount}
                          </Typography>
                        </TableContainer>
                        <br />
                        <Typography variant="p" component="p">
                          This is a computer generated invoice. No signature is
                          required.
                        </Typography>
                        <Typography variant="p" component="p">
                          Thank you for your business. This invoice was
                          generated on{" "}
                          {order.createdAt && order.createdAt.slice(0, 10)} at
                          {"    "}
                          {order.createdAt && order.createdAt.slice(11, 19)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </>
      </Box>
    </>
  );
};

export default Invoice;
